import userFeedbackFormTemplate from './user-feedback-form.tpl.html';
import './user-feedback-form.less';
import { starRatingComponentModule } from '../star-rating/star-rating';
import { userFeedbackModelModule } from '../../models/user-feedback-model';
import { appConfig } from '../../constants/app-config';

export const userFeedbackFormComponentModule = angular
  .module('Q.components.user-feedback-form', [
    starRatingComponentModule,
    userFeedbackModelModule,
  ])

  .component('userFeedbackForm', {
    bindings: {
      existingFeedback: '<',

      feedbackType: '@',
      featureName: '@',
      tags: '<',

      team: '<',
      assessment: '<',
      assessmentResult: '<',
      challenge: '<',
      solution: '<',

      onSubmit: '&',
    },
    controller: 'UserFeedbackFormCtrl',
    template: userFeedbackFormTemplate,
  })

  .controller(
    'UserFeedbackFormCtrl',
    function UserFeedbackFormCtrl(UserFeedback, appAlert, $window) {
      const ctrl = this;

      let existingFeedback;
      let didSubmit;

      ctrl.$onInit = () => {
        existingFeedback = ctrl.existingFeedback || {
          rating: 0,
          feedbackNotes: '',
        };
        ctrl.rating = existingFeedback.rating;
        ctrl.feedbackNotes = existingFeedback.feedbackNotes;
      };

      ctrl.submitText = () =>
        existingFeedback.id ? 'Update Feedback' : 'Submit Feedback';

      ctrl.feedbackStatusText = () =>
        didSubmit ? 'Thank you for your feedback!' : '';
      ctrl.feedbackStatusClass = () => (didSubmit ? 'text-success' : '');
      ctrl.hasChanges = () =>
        ctrl.rating !== existingFeedback.rating ||
        ctrl.feedbackNotes !== existingFeedback.feedbackNotes;

      ctrl.submit = () => {
        if (ctrl.disabled) return;
        didSubmit = false;
        ctrl.disabled = true;
        UserFeedback.saveOrCreate(existingFeedback, {
          rating: ctrl.rating,
          feedbackNotes: ctrl.feedbackNotes,
          feedbackType: ctrl.feedbackType,
          featureName: ctrl.featureName,
          tags: ctrl.tags,
          teamId: ctrl.team && ctrl.team.id,
          assessmentId: ctrl.assessment && ctrl.assessment.id,
          assessmentResultId: ctrl.assessmentResult && ctrl.assessmentResult.id,
          challengeId: ctrl.challenge && ctrl.challenge.id,
          solutionId: ctrl.solution && ctrl.solution.id,
          browserProperties: {
            appId: appConfig.appId,
            release: appConfig.release,
            ua: $window.navigator.userAgent,
            language: $window.navigator.language,
            windowSize: `${$window.innerWidth}x${$window.innerHeight}`,
          },
        })
          .then((newData) => {
            didSubmit = true;
            existingFeedback = newData;
            ctrl.onSubmit(newData);
          })
          .catch(appAlert.modelError)
          .finally(() => {
            ctrl.disabled = false;
          });
      };
    },
  );
